import React, { FC, useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Url } from "../../../Constants/Url";
import Spinner from "../../Common/Spinner";
import useFormValidation from "../../Dynamic/FormValidation";// Adjust the path as needed
import "./Login.scss"; // Adjust the path as needed
import notificationWebSocketService from "../../../Websocket/notificationWebSocketService";
import UATbelt from "../../Common/UATbelt";
import { RouteComponentProps } from "react-router";
import { Link } from 'react-router-dom';
import loginBanner from "../../../assets/images/login/WDTSbarrels.jpg";
import Constant from "../../../Constant";
import "../../../sass/responsive.scss";
import { Service } from "../../../Service/ApiService";
import { CommonService } from "../../../Service/CommonService";
import { CookieService } from "../../../Service/CookieService";
import LoginFooter from "../../Common/LoginFooter";
import Logo from "../../Logo/Logo";
import "./Login.scss"; // Adjust the path as needed
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Select from "react-select";

type FormValues = {
  username: string;
  password: string;
  city: string;
  ipAddress: string;
  state: string;
  country: string;
  postalCode: string;
  longitude: string;
  latitude: string;
  companyId: string;
  companyName: string;
};

type LoginProps = RouteComponentProps;

const Login: FC<LoginProps> = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isMultipleCompany, setIsMultipleCompany] = useState(false);
  const [companiesList, setCompaniesList] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [location, setLocation] = useState({
    city: "",
    ip: "",
    region_name: "",
    country_name: "",
    zip_code: "",
    longitude: "",
    latitude: "",
  });
  const [isCompanySuspended, setCompanySuspended] = useState(false);
  // const divRef = useRef<HTMLDivElement>(null);
  // const [divHeight, setDivHeight] = useState<number>(0);
  // useEffect(() => {
  //   if (divRef.current) {
  //     setDivHeight(divRef.current.clientHeight + 50);
  //     console.log(divHeight)
  //   }

  //   // Optional: Recalculate height on window resize
  //   const handleResize = () => {
  //     if (divRef.current) {
  //       setDivHeight(divRef.current.clientHeight + 50);
  //       console.log(divHeight)
  //     }
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  const initialState: FormValues = {
    username: "",
    password: "",
    city: "",
    ipAddress: "",
    state: "",
    country: "",
    postalCode: "",
    longitude: "",
    latitude: "",
    companyId: "",
    companyName: ""
  };

  const { formData, errors, handleChange, handleBlur, setErrors, setFormData } = useFormValidation(initialState);

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Fetch location details
  const getLocationDetails = async () => {
    try {
      const response = await fetch(Url.GET_LOCATION_DETAILS);
      const data = await response.json();
      setLocation(data);
    } catch (error) {
      console.error("Error fetching location details:", error);
    }
  };

  useEffect(() => {
    getLocationDetails();
  }, []);

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
  
    // Basic validation
    if (formData.username.trim().length === 0 || errors.username || formData.password.length === 0 || errors.password
      || (isMultipleCompany && (formData.companyName.length === 0 || errors.companyName))) {
      if (formData.username.trim().length === 0) {
        setErrors((prevState) => ({ ...prevState, username: "Please enter email" }));
      }
      if (formData.password.length === 0) {
        setErrors((prevState) => ({ ...prevState, password: "Please enter password" }));
      }
      if (isMultipleCompany && formData.companyName.length === 0) {
        setErrors((prevState) => ({ ...prevState, companyName: "Please select account owner" }));
      }
      return;
    }
  
    try {
      setIsLoading(true);
      
      const updatedFormData = {
        ...formData,
        username: formData.username?.trim().toLowerCase(), // Convert username to lowercase
        city: location.city,
        ipAddress: location.ip,
        state: location.region_name,
        country: location.country_name,
        postalCode: location.zip_code,
        longitude: location.longitude,
        latitude: location.latitude,
      };
  
      // Wrap the async call in another function for extra clarity
      const authenticate = async () => {
        const response = await Service.authentication(updatedFormData);
        return response;
      };
  
      // Await for the authentication response
      const response = await authenticate();
      setIsLoading(false);
      
      localStorage.removeItem("impersonatedUser");
      localStorage.removeItem("adminTokenBackup");
      localStorage.removeItem("adminUserBackup");
      localStorage.removeItem("loginAsUser");
      localStorage.removeItem("updateUserName");
      // Proceed with setting cookies and navigation
      CookieService.setAuthToken("authToken", response.data.accessToken);
      CookieService.setAuthToken("userRole", response.data.role);
      CookieService.setAuthToken("userId", response.data.userId);
      CookieService.setAuthToken("userName", response.data.name || "");
      CookieService.setAuthToken("companyId", response.data.companyId);
      CookieService.setAuthToken("companyName", response.data.companyName);
      localStorage.setItem("dashboardPrefrence", Constant.Profile.OWNER);
      localStorage.setItem("syncType", Constant.SyncType.KEGHOUND_TO_WHITEDOG);
      localStorage.setItem("showAssociatedCompany", "no");

      if (response.data.role === Constant.Role.SUPER_ADMIN) {
        history.push("master/dashboard");
      } else if (response.data.role === Constant.Role.ADMIN || response.data.role === Constant.Role.USER) {
        notificationWebSocketService.connect(response.data.userId);
        history.push("/user/inventories");
      } else if (response.data.role === Constant.Role.WAREHOUSE) {
        notificationWebSocketService.connect(response.data.userId);
        history.push("/master/storage-dashboard");
      }
  
    } catch (error: any) {

      const errorMessage = error?.response?.data?.errorMessage;
      if (error.response && error.response.status === 300) {
        setIsMultipleCompany(true);
        setCompaniesList(error.response.data)

      }else if (errorMessage && errorMessage === "Your account owner has been suspended.") {
        setCompanySuspended(true)

      } else if(error.response.status === 401){
         CommonService.Toast.fire({
          title: "Invalid Credentials!",
          icon: "error",
        });

      } else if (error.response && error.response.status === 500) {
        CommonService.Toast.fire({
          title: errorMessage,
          icon: "error",
        });

      }
      
      setIsLoading(false);
    }
  };

  const companyOptions = companiesList.map((company: any) => ({
    value: company.id,
    label: company.companyName,
  }));

  const handleCompanySelect = (id: string) => {
    const selectedCompany = companiesList.find((company) => company.id === id);

    if (selectedCompany) {
      setErrors((prevErrors) => ({ ...prevErrors, companyName: "" }));
      setFormData((prevState) => ({
        ...prevState,
        companyName: selectedCompany.companyName,
        siteId: selectedCompany.siteId,
        companyId: selectedCompany.id,
      }));
    }
  };

  const handleBackToLogin=() =>{
    setIsMultipleCompany(false);
    setCompanySuspended(false);
    setFormData((prevState) => ({
        ...prevState,
        companyName: "",
        siteId: "",
        companyId: ""
    }));
  }

  const redirectToSignupPage = () => {
    history.push('/signup');
  }

  const redirectToMarketPlace = () => {
    history.push('/user/inventories');
  }

  return (
    <>
      <UATbelt />
      <div className="login text-start">
        <div className="mx-auto d-flex align-items-center flex-column">
          <div className="login__form">
            <div className="row d-flex align-items-center m-0">
              <div className="col-lg-6 px-0">
                <div className="login__form--outer">
                  <div className="row mb-3vh mx-0">
                    {(isMultipleCompany || isCompanySuspended) && <button className="back-btn btn d-flex align-items-center gap-2" onClick={handleBackToLogin}><span className="arrow-wrapper"><ArrowBackIcon /></span><span className="back-btn-text"> Back to login</span></button>}
                    <div className="col-12 px-0">
                      <a target="_blank" href="https://whitedogllc.com">
                        <Logo size="auto" />
                      </a>
                      <p className="logo-sub__text mb-0 mt-2">
                        Presented by{" "}
                        <a
                          target="_blank"
                          href="https://whitedogllc.com"
                          className="ms-1"
                        >
                          White Dog Trading & Storage
                        </a>
                      </p>
                    </div>
                  </div>
                  {!isCompanySuspended ? (
                    <>
                      <div className="row mb-2vh mx-0">
                        <div className="col-12 px-0">
                          {!(isMultipleCompany || isCompanySuspended) && <button className="back-btn btn d-flex align-items-center gap-2 mb-2" onClick={redirectToMarketPlace}><span className="arrow-wrapper"><ArrowBackIcon/></span><span className="back-btn-text"> Back to Marketplace</span></button>}
                          <h1 className="login__heading">Welcome back!</h1>
                          <p className="login__text mb-0">
                            Enter your credentials to access your account
                            securely.
                          </p>
                        </div>
                      </div>
                      <form
                        className="form__inner row d-flex m-0"
                        onSubmit={handleSubmit}
                      >
                    {!isMultipleCompany ? <>
                        <div className="col-12 mb-2vh px-0 login-form-group">
                          <label htmlFor="loginEmail" className="form-label">
                            Email{" "}
                            <span className="star-required text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className={`form-control ${
                              errors.username ? "is_invalid" : ""
                            }`}
                            placeholder="Enter your email"
                            value={formData.username}
                            onChange={(e) => {
                              e.target.value = e.target.value.trim();
                              handleChange(e);
                            }}
                            onBlur={(e) => {
                              e.target.value = e.target.value.trim();
                              handleBlur(e);  
                            }}
                            name="username"
                            id="loginEmail"
                          />
                          {errors.username && (
                            <div className="error-message">
                              {errors.username}
                            </div>
                          )}
                        </div>
                        <div className="col-12 mb-3vh px-0 login-form-group">
                          <label htmlFor="loginPassword" className="form-label">
                            Password{" "}
                            <span className="star-required text-danger">*</span>
                          </label>
                          <div className="position-relative">
                            <input
                              type={showPassword ? "text" : "password"}
                              className={`form-control ${
                                errors.password ? "is_invalid" : ""
                              }`}
                              placeholder="Enter your password"
                              value={formData.password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name="password"
                              id="loginPassword"
                            />
                            <button
                              className="btn text-secondary position-absolute top-50 end-0 translate-middle-y"
                              type="button"
                              onClick={togglePasswordVisibility}
                            >
                              {showPassword ? <FaEye /> : <FaEyeSlash />}
                            </button>
                          </div>
                          {errors.password && (
                            <div className="error-message">
                              {errors.password}
                            </div>
                          )}
                        </div>
                        <div className="col-12 col-sm-6 mb-2vh offset-sm-6 px-0">
                          <div className="form-link text-end">
                            <Link to="/forgot-password">Forgot Password?</Link>{" "}
                          </div>
                        </div>
                    </>
                    : <div className="col-12 mb-2vh px-0 login-form-group">
                        <Select
                          className={`select-company-dropdown form-control w-100 multi-select-dropdown ${errors.companyName ? "is_invalid" : ""
                            }`}
                          options={companyOptions}
                          value={companyOptions.find((option) => option.value === formData.companyName)}
                          onChange={(selectedOption) => { handleCompanySelect(selectedOption?.value); }}
                          components={{
                            DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                            IndicatorSeparator: () => null, // Remove the default separator
                          }}
                          isSearchable
                          placeholder="Select Account Owner"
                          />
                          {errors.companyName && (
                                  <div className="error-message">
                                    {errors.companyName}
                                  </div>
                          )}
                    </div>
                  }
                        {/*<div className="col-12 col-sm-6 mb-1 mb-sm-3">
                  <div className="form-check">
                     <input className="form-check-input" type="checkbox" id="rememberMe" />
                    <label className="form-check-label" htmlFor="rememberMe">
                      Remember Me
                    </label> 
                  </div>
                </div>*/}
                        
                        <div className="col-12 mb-2vh px-0">
                          <div className="form__btn--group row d-flex flex-wrap justify-content-center">
                            <div className="col-6">
                              <button
                                type="submit"
                                className="btn secondary-btn w-100"
                                disabled={isLoading}
                              >
                                {isLoading && <Spinner />}
                                Login
                              </button>
                            </div>
                          </div>
                          <div className="signup-text-wrapper text-center">
                            <p>Don’t have an account? <span className="signup-link cursor-pointer" onClick={redirectToSignupPage}>Signup</span></p>
                          </div>
                        </div>
                      </form>
                    </>
                  ) : (
                    <div className="d-flex align-items-baseline gap-2 suspended-acount-wrapper">
                      <span>
                        <svg
                          width="48"
                          height="48"
                          viewBox="0 0 48 48"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M24 30C26.0711 30 27.75 28.3211 27.75 26.25C27.75 24.1789 26.0711 22.5 24 22.5C21.9289 22.5 20.25 24.1789 20.25 26.25C20.25 28.3211 21.9289 30 24 30Z"
                            stroke="#BF6038"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M24 30V34.5"
                            stroke="#BF6038"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M39 16.5H9C8.17157 16.5 7.5 17.1716 7.5 18V39C7.5 39.8284 8.17157 40.5 9 40.5H39C39.8284 40.5 40.5 39.8284 40.5 39V18C40.5 17.1716 39.8284 16.5 39 16.5Z"
                            stroke="#BF6038"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M16.5 16.5V10.5C16.5 8.51088 17.2902 6.60322 18.6967 5.1967C20.1032 3.79018 22.0109 3 24 3C25.9891 3 27.8968 3.79018 29.3033 5.1967C30.7098 6.60322 31.5 8.51088 31.5 10.5V16.5"
                            stroke="#BF6038"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <div className="suspended-header">
                          <h1>Your account is Suspended</h1>
                        </div>
                        <p className="suspended-text">
                          Your account has been suspended due to a violation of
                          our terms of service. Please contact support for more information
                        </p>
                        {/* <div className="text-center">
                        <button className="primary-btn" type="button">
                          Contact Support
                        </button>
                      </div> */}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-6 d-none d-lg-block px-0">
                <div className="login__form--banner d-flex justify-content-center">
                  <img src={loginBanner} alt="logo" />
                </div>
              </div>
            </div>
          </div>
          <div className="login-footer-wrapper">
            <LoginFooter />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
